import {
  ObservabilityToolType,
  TeamExternalIntegrationAuthenticationStatus,
  type TeamExternalIntegrationGcp,
  type TeamExternalIntegration
} from 'types/api/status-checks/status-check'

import type {
  AuthenticationRequestBodyGcp,
  CreateAuthenticationRequestParams
} from 'queries/external-integrations/types'

export function isTeamExternalIntegrationGcp(
  integration: TeamExternalIntegration
): integration is TeamExternalIntegrationGcp {
  const { domain, observabilityToolType } = integration
  return Boolean(domain && observabilityToolType === ObservabilityToolType.GCP)
}

export function getGcpAuthenticationPayload(
  projectId: string,
  serviceAccountId: string
): [CreateAuthenticationRequestParams, AuthenticationRequestBodyGcp] {
  const observabilityToolType = ObservabilityToolType.GCP

  return [
    {
      domain: projectId,
      observabilityToolType
    },
    {
      integrationSpecificValues: { serviceAccount: serviceAccountId },
      name: observabilityToolType,
      privateNetwork: false,
      lastAuthenticationStatus:
        TeamExternalIntegrationAuthenticationStatus.Authenticated
    }
  ]
}

/**
 * Given a path to a Deployment Template (json), creates a link that GCP
 * uses to consume the template.
 */
export function getGcpMetadataAuthenticationUrlFromResponse(cdnPath: string) {
  /* TODO: replace with actual url */
  return `https://google-template-tbd/uri/${encodeURIComponent(cdnPath)}`
}
